import Vue from 'vue';

export const _setProp = (obj, props, value) => {
  const prop = props.shift();
  if (!obj) {
    obj = {};
  }
  if (!obj[prop]) {
    Vue.set(obj, prop, {});
  }
  if (!props.length) {
    if (value && typeof value === 'object' && !Array.isArray(value)) {
      obj[prop] = { ...obj[prop], ...value };
    } else {
      obj[prop] = value;
    }
    return;
  }
  _setProp(obj[prop], props, value);
};

export const setProp = (obj, props, value) => {
  const propsArray = props.split('.');
  return _setProp(obj, propsArray, value);
};

export const _getProp = (obj, props) => {
  const prop = props.shift();
  if (!obj[prop] || !props.length) {
    return obj[prop];
  }
  return _getProp(obj[prop], props);
};

export const getProp = (obj, props) => {
  const propsArray = props.split('.');
  return _getProp(obj, propsArray);
};

export const _deleteProp = (obj, props) => {
  const prop = props.shift();
  if (!obj[prop]) {
    return;
  }
  if (!props.length) {
    Vue.delete(obj, prop);
    return;
  }
  _deleteProp(obj[prop], props);
};

export const deleteProp = (obj, props) => {
  const propsArray = props.split('.');
  return _deleteProp(obj, propsArray);
};
